import { rankOf } from "../data/levels.js";
import logo from "../assets/cllxtv-logo.png";

export default function Menu({
  open,
  onClose,
  onNav,
  onIncident,
  userRank,
  onLock,
  unlinked,
  canFile,
}) {
  if (!open) return null;

  // Entries with a minLevel disappear entirely below that tier.
  const item = (emoji, label, view, minLevel) => {
    if (minLevel && userRank < rankOf(minLevel)) return null;
    return (
      <button
        key={label}
        className="ditem"
        onClick={() => {
          onClose();
          onNav(view);
        }}
      >
        <span className="demoji">{emoji}</span>
        <span>{label}</span>
      </button>
    );
  };

  // A row that runs something instead of navigating — filing a report opens a
  // dialog over wherever you already are.
  const action = (emoji, label, fn, minLevel) => {
    if (minLevel && userRank < rankOf(minLevel)) return null;
    return (
      <button
        key={label}
        className="ditem"
        onClick={() => {
          onClose();
          fn();
        }}
      >
        <span className="demoji">{emoji}</span>
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div className="drawer">
      <div className="panel">
        <div className="dhead">
          <img src={logo} alt="" />
          <div>
            <div className="dt">The Room</div>
            <div className="ds">CLLXTV · Internal Hub</div>
          </div>
        </div>

        <div className="dsec">Workspace</div>
        {item("🏠", "Home", "home")}
        {/* An unlinked member has no Planning Center identity yet, so the
            workspace and leadership sections would all be empty or refused.
            Their menu mirrors the four sections on their home screen. */}
        {!unlinked && (
          <>
            {item("🔍", "Search the hub", "search")}
            {item("🪪", "My Dashboard", "dashboard")}
            {item("🚀", "Onboarding", "onboard")}
            {item("📜", "SOPs & Playbooks", "ops")}
            {item("📚", "Resources", "docs")}
            {item("🧬", "Culture Codes", "culture")}
            {item("🧭", "myTRiBE+ Journey", "tribe")}
            {item("🗓️", "myTRiBE Calendar", "calendar")}
            {item("🙏", "Prayer & Testimony Wall", "wall")}
            {item("⚓", "Ship Happens", "ship-happens")}
            {item("🙌", "Join the Dream Team", "dreamteam")}
            {item("🎵", "CLLXTV Music", "worship")}
            {item("🎨", "Creative", "creative")}

            <div className="dsec">Leadership</div>
            {item("📈", "LEADERSHiP+", "leadershipplus", "leader")}
            {item("🤝", "Request a meeting", "meet", "leader")}
            {item("🗂️", "Org Chart", "org", "director")}
            {/* Filing and reading are separate rights. A member granted the
                reporter capability sees the form and not the archive, which is
                the whole point of the grant — so this row is gated on the
                capability while the row below stays gated on rank. */}
            {canFile && action("🚨", "Report an incident", onIncident)}
            {item("🗄️", "Incident reports", "incidents", "leader")}
          </>
        )}

        <div className="dsec">Tools</div>
        {item("🐞", "Report an issue", "report")}
        {!unlinked && item("📊", "Usage & analytics", "analytics", "senior")}
        {!unlinked && item("🔑", "Roles & access", "admin", "senior")}

        <div className="dsec">Session</div>
        <button
          className="ditem"
          onClick={() => {
            onClose();
            onLock();
          }}
        >
          <span className="demoji">🔐</span>
          <span>Sign out</span>
        </button>
      </div>
      <button className="scrim" aria-label="Close menu" onClick={onClose} />
    </div>
  );
}
